export default "__VITE_ASSET__a034f9a9__"